"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Enterprise;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// All enterprise related data
var Enterprise = (_Enterprise = {
  enterprise: {
    nl: "Onderneming",
    fr: "Entreprise",
    en: "Enterprise",
    de: "Unternehmen"
  },
  name_translations: {
    nl: "Naam",
    fr: "Nom",
    en: "Name",
    de: "Name"
  },
  description_translations: {
    nl: "Beschrijving",
    fr: "Déscription",
    en: "Description",
    de: "Beschreibung"
  },
  entrepreneur_info: {
    nl: "Ondernemingsgegevens",
    fr: "Information d'entrepreneur",
    en: "Entrepreneur Information",
    de: "Unternehmensinformationen"
  },
  enterprises: {
    nl: "Ondernemingen",
    fr: "Entreprises",
    en: "Enterprises",
    de: "Unternehmen"
  },
  all_enterprises: {
    nl: "Alle ondernemingen",
    fr: "Toutes les entreprises",
    en: "All enterprises",
    de: "Alle Unternehmen"
  },
  total_enterprises: {
    nl: "Totaal ondernemingen",
    fr: "Total entreprises",
    en: "Total enterprises",
    de: "Gesamtanzahl der Unternehmen"
  },
  establishment: {
    nl: "Vestiging",
    fr: "Établissement",
    en: "Establishment",
    de: "Niederlassung"
  },
  establishment_info: {
    nl: "Vestigingsgegevens",
    fr: "Informations sur l'établissement",
    en: "Establishment info",
    de: "Niederlassungsinformationen"
  },
  establishments: {
    nl: "Vestigingen",
    fr: "Établissements",
    en: "Establishments",
    de: "Niederlassungen"
  },
  establishment_name: {
    nl: "Vestigingsnaam",
    fr: "Nom de l'établissement",
    en: "Establishment name",
    de: "Niederlassungsname"
  },
  establishment_trade_name: {
    nl: "Handelsnaam van vestiging",
    fr: "Nom commercial de l'établissement",
    en: "Trade name of establishment",
    de: "Handelsname der Niederlassung"
  },
  number_of_establishment: {
    nl: "Nummer vestigingseenheid",
    fr: "Numéro d'établissement",
    en: "Number of the establishment",
    de: "Nummer der Niederlassung"
  },
  id_cbe: {
    nl: "ID KBO",
    fr: "ID BCE",
    en: "ID CBE",
    de: "ID CBE"
  },
  enterprise_name: {
    nl: "Naam onderneming",
    fr: "Nom d'entreprise",
    en: "Enterprise name",
    de: "Name des Unternehmens"
  },
  enterprise_type: {
    nl: "Type onderneming",
    fr: "Type d'entreprise",
    en: "Enterprise type",
    de: "Unternehmenstyp"
  },
  identity: {
    nl: "Identiteit",
    fr: "Identité",
    en: "Identity",
    de: "Identität"
  },
  group_name: {
    nl: "Groepsnaam",
    fr: "Nom du groupe",
    en: "Group name",
    de: "Gruppenname"
  },
  trade_name: {
    nl: "Handelsnaam",
    fr: "Nom commercial",
    en: "Trade name",
    de: "Handelsname"
  },
  juridical_form: {
    nl: "Juridische vorm",
    fr: "Forme juridique",
    en: "Juridical form",
    de: "Rechtsform"
  },
  commercial_transaction: {
    nl: "Commerciële transactie",
    fr: "Transaction commerciale",
    en: "Commercial transaction",
    de: "Kommerzielle Transaktion"
  },
  vat_number: {
    nl: "BTW-nummer",
    fr: "Numéro de TVA",
    en: "VAT number",
    de: "USt-IdNr"
  },
  entrepreneurs_number: {
    nl: "OND. NR./BTW NR",
    fr: "Numéro d'entreprise",
    en: "Enterprise number",
    de: "Unternehmensnummer"
  },
  abbreviation: {
    nl: "Afkorting",
    fr: "Abréviation",
    en: "Abbreviation",
    de: "Abkürzung"
  },
  legal_info: {
    nl: "Legale info",
    fr: "Informations légales",
    en: "Legal info",
    de: "Rechtsinformationen"
  },
  legal_situation: {
    nl: "Rechtstoestand",
    fr: "Situation juridique",
    en: "Legal situation",
    de: "Rechtliche Lage"
  },
  external_identification: {
    nl: "Externe identificatie",
    fr: "Identification externe",
    en: "External identification",
    de: "Externe Identifikation"
  },
  establishment_number: {
    nl: "Vestigingsnummer",
    fr: "Numéro d'établissement",
    en: "Establishment number",
    de: "Niederlassungsnummer"
  }
}, _defineProperty(_Enterprise, "establishment_name", {
  nl: "Vestigingsnaam",
  fr: "Nom d'établissement",
  en: "Establishment name",
  de: "Niederlassungsname"
}), _defineProperty(_Enterprise, "agreement", {
  nl: "Overeenkomst",
  fr: "Accord",
  en: "Agreement",
  de: "Vereinbarung"
}), _defineProperty(_Enterprise, "new_agreement", {
  nl: "Nieuwe overeenkomst",
  fr: "Nouvel accord",
  en: "New agreement",
  de: "Neue Vereinbarung"
}), _defineProperty(_Enterprise, "order_form", {
  nl: "Bestelbon",
  fr: "Bon de commande",
  en: "Order form",
  de: "Bestellformular"
}), _defineProperty(_Enterprise, "new_order_form", {
  nl: "Nieuwe bestelbon",
  fr: "Nouveau bon de commande",
  en: "New order form",
  de: "Neues Bestellformular"
}), _defineProperty(_Enterprise, "registration", {
  nl: "Registratie",
  fr: "Enregistrement",
  en: "Registration",
  de: "Registrierung"
}), _defineProperty(_Enterprise, "registration_number", {
  nl: "Registratie nummer",
  fr: "Numéro d'enregistrement",
  en: "Registration number",
  de: "Registrierungsnummer"
}), _defineProperty(_Enterprise, "legal_form", {
  nl: "Rechtsvorm",
  fr: "Forme légale",
  en: "Legal form",
  de: "Rechtsform"
}), _defineProperty(_Enterprise, "status", {
  nl: "Status",
  fr: "Statut",
  en: "Status",
  de: "Status"
}), _defineProperty(_Enterprise, "categories", {
  nl: "Categorieën",
  fr: "Catégories",
  en: "Categories",
  de: "Kategorien"
}), _defineProperty(_Enterprise, "category", {
  nl: "Categorie",
  fr: "Catégorie",
  en: "Category",
  de: "Kategorie"
}), _defineProperty(_Enterprise, "rubrics", {
  nl: "Rubrieken",
  fr: "Rubriques",
  en: "Rubrics",
  de: "Rubriken"
}), _defineProperty(_Enterprise, "nacebel", {
  nl: "Nacebel",
  fr: "Nacebel",
  en: "Nacebel",
  de: "Nacebel"
}), _defineProperty(_Enterprise, "magazines", {
  nl: "Magazines",
  fr: "Magazines",
  en: "Magazines",
  de: "Magazine"
}), _defineProperty(_Enterprise, "promos", {
  nl: "Promo's",
  fr: "Promos",
  en: "Promos",
  de: "Promos"
}), _defineProperty(_Enterprise, "price_per_click", {
  nl: "Prijs per klik",
  fr: "Prix par clic",
  en: "Price per click",
  de: "Preis pro Klick"
}), _defineProperty(_Enterprise, "price_per_hour", {
  nl: "Prijs per uur",
  fr: "Prix par heure",
  en: "Price per hour",
  de: "Preis pro Stunde"
}), _defineProperty(_Enterprise, "price_per_keyword", {
  nl: "Prijs per keyword",
  fr: "Prix par mot-clé",
  en: "Price per keyword",
  de: "Preis pro Keyword"
}), _Enterprise);
var _default = Enterprise;
exports["default"] = _default;